import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import PageHeader from '~/components/PageHeader';
import LoadingScreen from '~/screens/LoadingScreen';
import { EmptyScreen } from '~/screens/ScenariosScreen/EmptyScreen';
import { ScenarioAside } from '~/screens/ScenariosScreen/ScenarioAside';
import { ScenarioList } from '~/screens/ScenariosScreen/ScenarioList';
import { getScenarioListColumns } from '~/screens/ScenariosScreen/ScenarioListColumns';
import { ScenariosTemplates } from '~/screens/ScenariosScreen/ScenarioTemplates';
import {
  emptyState,
  feedbackWidgetsURL,
} from '~/screens/ScenariosScreen/consts';
import ScenariosStore from '~/screens/ScenariosScreen/store';
import { Props, State } from '~/screens/ScenariosScreen/types';
import Screen from '~/screens/Screen';
import { setGtm } from '~/utils/setGtm';
import './style.css';

@inject('authStore')
@observer
class ScenariosScreen extends Component<Props, State> {
  store: ScenariosStore = new ScenariosStore();

  state: State = { ...emptyState };

  isFeedback = this.props.location.pathname === feedbackWidgetsURL;

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.isFeedback = nextProps.location.pathname === feedbackWidgetsURL;
      this.setState({ ...emptyState });
    }
  }

  async componentDidMount() {
    /**  Отправка события enter_to_leads_constructor для GA */
    if (this.isFeedback) setGtm('enter_to_leads_constructor');

    await Promise.all([
      this.store.fetchScenarios(),
      this.store.fetchTemplates(),
      this.store.getScenariosCount(),
    ]);
  }

  handleClickCreate = () => this.setState({ isTemplatesVisible: true });

  handleSaveScenario = async () => {
    this.setState({
      selectedPreset: null,
      selectedScenario: null,
      isTemplatesVisible: false,
    });

    await this.store.getScenariosCount();
    await this.store.fetchScenarios();
  }

  render() {
    const { authStore } = this.props;
    const rightsForWidgets = authStore.currentUser.rightsModel.find(
      (e: { toString: () => string }) => e.toString() === 'LIST_SCENARIOS'
    );

    const {
      availableScenarios,
      availableFeedbackScenarios,
      scenariosCount,
      isScenariosLoading,
      isTemplatesLoading,
      isFetchingScenariosCount,
      activeScenariosCount,
      isFetchingPrivacyPolicy,
    } = this.store;

    const isLoaderScreenShown =
      (isScenariosLoading && isTemplatesLoading) ||
      isFetchingScenariosCount ||
      isFetchingPrivacyPolicy;

    if (isLoaderScreenShown) {
      return <LoadingScreen />;
    }

    const isScenariosExisting = this.isFeedback
      ? availableFeedbackScenarios.length > 0
      : availableScenarios.length > 0;

    const isEmptyScreenShown =
      !this.state.isTemplatesVisible &&
      (!rightsForWidgets || !isScenariosExisting);

    if (isEmptyScreenShown) {
      return <EmptyScreen self={this} />;
    }

    const filterStatsByScenarioId = (scenarioId: number) => {
      return this.store.statistics.filter(
        (statsElement: IWidgetStatistics) => statsElement.scenarioId === scenarioId
      )[0];
    };

    const scenarioListColumns = getScenarioListColumns({
      setErrorMessageVisible: () =>
        this.setState({ isErrorMessageVisible: true }),
      setErrorWhenCheckScriptException: () =>
        this.setState({ isErrorWhenCheckScriptException: true }),
      filterStatsByScenarioId,
      getScenariosCount: this.store.getScenariosCount,
    });

    return (
      <Screen className="scenarios-screen" noPadding>
        <PageHeader
          title="Виджеты"
          className="scenarios-screen__title"
          aside={(
            <ScenarioAside
              isScenariosExisting={isScenariosExisting}
              activeScenariosCount={activeScenariosCount}
              currentCount={scenariosCount.currentCount}
            />
          )}
        />
        {isScenariosExisting ? (
          <ScenarioList self={this} scenarioListColumns={scenarioListColumns} />
        ) : (
          <ScenariosTemplates self={this} />
        )}
      </Screen>
    );
  }
}

export default ScenariosScreen;
